<template>
  <div class="appt-book">
    <div class="book-title"><p v-html="response.responseHeadline"></p></div>
    <div class="book-description">
      <p class="appt-text-subhead"><span v-html="response.responseMessage"></span></p>
      <p class="appt-text-details"><span v-html="response.responseDetails"></span></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  computed: {
    response() {
      return this.$store.state.form_response;
    },
  },
  methods: {

  }
}
</script>
<style>
.appt-book .book-title p{font-size: 20px;font-weight: bold;color: #222;text-align:center;line-height:normal;}
.appt-book .book-description p{font-size: 16px;line-height: 26px;margin: 30px 0;color: #666666;text-align:center;}
@media screen and (max-width: 767px){
  .appt-book .book-title p{font-size: 18px;}
}
@media screen and (max-width: 400px){
  .appt-book .book-title p {font-size: 16px;}
}
</style>